var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-md-editor',{attrs:{"value":_vm.value,"height":"400px","mode":"edit","placeholder":_vm.placeholder,"left-toolbar":"h bold italic | ul ol hr | link","right-toolbar":"preview fullscreen"},on:{"change":_vm.onChange}})}
var staticRenderFns = []

export { render, staticRenderFns }